import { Badge } from "@/components/ui/badge";
const technicalLabels = ["Direção de Conteúdo", "Captação em 4K", "Áudio de Alta Qualidade", "Cortes para Redes", "Estratégia de Conteúdo", "Gravação em Pinheiros", "Produção Completa", "Conteúdo com Autoridade", "Otimização para Alcance"];
export default function Diferencial() {
  return <section id="diferencial" className="relative overflow-hidden bg-background py-24 lg:py-32">
      <div className="absolute inset-0 pointer-events-none flex items-center justify-end overflow-hidden z-0">
        <svg className="w-[150%] h-[150%] max-w-none translate-x-1/4 opacity-100" viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg" style={{
        color: "hsla(270, 90%, 70%, 0.05)"
      }} aria-hidden="true">
          <circle cx="400" cy="400" r="400" stroke="currentColor" strokeWidth="2" />
          <circle cx="400" cy="400" r="300" stroke="currentColor" strokeWidth="2" />
          <circle cx="400" cy="400" r="200" stroke="currentColor" strokeWidth="2" />
          <circle cx="400" cy="400" r="100" stroke="currentColor" strokeWidth="2" />
          <path d="M400 0V800M0 400H800" stroke="currentColor" strokeWidth="1" strokeDasharray="10 10" />
        </svg>
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-8 items-center">
          <div className="lg:col-span-5 lg:col-start-1">
            <h2 className="font-default text-5xl md:text-6xl lg:text-7xl font-bold text-foreground leading-[1.1] tracking-tight">
              Qualidade <br />
              <span className="text-primary">+</span> estratégia
            </h2>
            <p className="mt-8 text-lg md:text-xl text-muted-foreground leading-relaxed max-w-lg">
              Unimos produção audiovisual profissional com visão estratégica para criar conteúdos que posicionam marcas, geram autoridade e impulsionam resultados reais.
            </p>
          </div>

          <div className="lg:col-span-6 lg:col-start-7 flex flex-wrap gap-3 md:gap-4 content-start">
            {technicalLabels.map((label, i) => <Badge key={i} data-index={i} variant="outline" className="bg-primary/10 text-primary border-transparent hover:bg-primary/20 text-sm md:text-base py-2.5 px-5 rounded-full transition-colors duration-300 font-medium shadow-none">
                {label}
              </Badge>)}
          </div>
        </div>
      </div>
    </section>;
}